import { grid } from '../../script'

let toggleMobileNav = ( target ) => {
	if ( 'undefined' === typeof target ) {
		target = document.querySelector('.nav-bar .hamburger')
	}

	target.classList.toggle('active')

	var body = document.querySelector('body')
	body.classList.toggle('mobile-menu-active')

	hideSearch()

	return body.classList.contains('mobile-menu-active')
}

let hideMobileNav = ( target ) => {
	if ( 'undefined' === typeof target ) {
		target = document.querySelector('.nav-bar .hamburger')
	}

	target.classList.remove('active')
	target.value = ''

	var body = document.querySelector('body')
	body.classList.remove('mobile-menu-active')
}

let hideSearch = ( target ) => {

	$('.search-dropdown').fadeOut(200)

	setTimeout(() => {
		if ( 'undefined' === typeof target ) {
			target = document.getElementById('search')
		}

		document.getElementById('menu-search-container').classList.remove('search-open')

		target.classList.remove('active')
	}, 200)

}

$( document ).ready( function() {
	// Search toggling.
	console.log( $( '#main-nav__search-icon-button' ) );
	$( '#main-nav__search-icon-button' ).on( 'click', function( e ) {
		console.log( 'CLICKED' );
		var $this = $( this );

		$this.toggleClass( 'open' );

		var $searchBox = $( '#main-nav__search-box' );

		$searchBox.slideToggle( function() { $searchBox.toggleClass( 'open' ); } );
	} )
} );

$( document ).ready( function() {
	// Search toggling.
	console.log( $( '#mobile-nav__search-icon-button' ) );
	$( '#mobile-nav__search-icon-button' ).on( 'click', function( e ) {
		console.log( 'CLICKED' );
		var $this = $( this );

		$this.toggleClass( 'open' );

		var $searchBox = $( '#mobile-nav__search-box' );

		$searchBox.slideToggle( function() { $searchBox.toggleClass( 'open' ); } );
	} )
} );

var mobileMenuActive = false;

$( document ).ready(() => {

	// Toggle active class when hamburger is clicked
	var hamburger = document.querySelector('.nav-bar .hamburger');
	if ( hamburger ) {
		hamburger.onclick = ( e ) => {
			mobileMenuActive = toggleMobileNav( e.currentTarget )
		}
	}


	// Mobile main-nav dropdown
	$( document ).on( 'click', '.mobile-menu-active #menu-main-menu .arrow', ( e ) => {
		e.currentTarget.parentNode.classList.toggle('active')
	})

	$('#resources-for-button').menuToggle();

	// On resize remove active class from mobile if too large
	window.addEventListener( 'resize', () => {
		if ( mobileMenuActive && window.matchMedia( '(min-width: ' + grid.mediumScreen + ')' ).matches ) {
			mobileMenuActive = toggleMobileNav()
		}
	})

	// Search
	document.querySelector('#search').onclick = ( e ) => {
		console.log( e.target, e.currentTarget );

		if ( window.matchMedia( '(min-width: ' + grid.mediumScreen + ')' ).matches ) {
			// desktop menu

			if (
				( e.target.classList.contains('search-icon') || e.target.classList.contains('search-icon-button') )
				&& e.currentTarget.classList.contains('active')
			) {
				// if you click the search icon when active
				if ( '' !== document.querySelector('#search-box input').value ) {
					$('#search-box').find('form').submit()
				}
			} else if ( e.target.classList.contains('close') || e.target.classList.contains('icon-close') ) {
				hideSearch( e.currentTarget )
			} else if ( e.target.classList.contains('search-icon') || e.target.classList.contains('search-icon-button') ) {
				// when opened
				e.currentTarget.classList.add('active')
				document.querySelector('#search-box input').focus()
				document.getElementById('menu-search-container').classList.add('search-open')
				$('.search-dropdown').fadeIn(200)
			}

		} else {
			// mobile menu

			if ( e.target.classList.contains('search-icon') ) {

				// toggle active state for the search
				e.currentTarget.classList.toggle('active')
				document.getElementById('menu-search-container').classList.toggle('search-open')

				if ( ! e.currentTarget.classList.contains('active') ) {
					hideSearch( e.currentTarget )
					$('.search-dropdown').hide()
				} else {
					hideMobileNav()
					document.querySelector('#search-box input').focus()
					$('.search-dropdown').show()
				}

			} else if ( e.target.classList.contains('icon-search') ) {
				if ( '' !== document.querySelector('#search-form input').value ) {
					document.querySelector('#search-form').submit()
				}
			}

		}

	}
})



// WEBPACK FOOTER //
// ./assets/js/components/layout/main-nav.js